import React, { useEffect, useState } from 'react'
import './ProductoDetalleTotal.scss'
import { connect } from 'react-redux'
import { setTotalSelected } from '../actions'

const ProductoDetalleTotal = (props) => {

    const { producto } = props

    const [total, setTotal] = useState(1)

    useEffect(() => {
        if (props.formatSelected === 'UVenta2021Suelto') {
            setTotal(props.quantitySelected)
            props.setTotalSelected(props.quantitySelected)
        } else if (props.formatSelected === 'expositor') {
            setTotal(props.quantitySelected)
            props.setTotalSelected(props.quantitySelected)
        } else {
            setTotal(producto[props.formatSelected] * props.quantitySelected)
            props.setTotalSelected(producto[props.formatSelected] * props.quantitySelected)
        }
    }, [props.quantitySelected, props.formatSelected, props.producto])

    return (
        <div className="detalle-total">
            <div className="titulo"><p>Total</p></div>
            <div className="cantidad"><p>{total} unidades</p></div>
        </div>
    )
}

const mapDispatchToProps = {
    setTotalSelected
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ProductoDetalleTotal);